function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import * as React from 'react';
import './WidgetBar.css';
var WidgetBar = /*#__PURE__*/function (_React$Component) {
  _inherits(WidgetBar, _React$Component);
  function WidgetBar(props) {
    var _this;
    _classCallCheck(this, WidgetBar);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(WidgetBar).call(this, props));
    _this.utilityRef = React.createRef();
    _this._isMounted = false;
    return _this;
  }
  _createClass(WidgetBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props = this.props,
        instrumentId = _this$props.instrumentId,
        metadata = _this$props.metadata,
        userId = _this$props.userId;
      window.require(['base/application-loader', 'backbone', 'jquery'], function (loader, Backbone, $) {
        $(function () {
          var appChannel = Backbone.Radio.channel('application');
          appChannel.reply(metadata);
          appChannel.reply('dataOwnerUserId', userId);
          var module = 'dm-spu-record-editor';
          var version = window.spaOptions.moduleVersions[module];
          var path = 'node_modules/' + module + '/' + version + '/application';
          var el = _this2.utilityRef.current;
          var options = {
            el: el,
            $el: $(el),
            dataOwnerUserId: userId,
            instrumentId: instrumentId,
            createContainer: true,
            showEmulateBar: false
          };
          _this2._isMounted = true;
          loader.initialize(path, options).then(function (application) {
            if (_this2._isMounted) {
              application.start();
              _this2.application = application;
            }
          });
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      if (this.application) {
        this.application.stop();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        ref: this.utilityRef
      });
    }
  }]);
  return WidgetBar;
}(React.Component);
export { WidgetBar as default };